import React from 'react';
import { NavLink } from 'react-router-dom';
import { House, Search, Activity, User, TrainFront, Users } from 'lucide-react';
import './MobileNav.css';

const MOBILE_TABS = [
  { path: '/', label: 'Home', icon: House },
  { path: '/trains', label: 'Search', icon: Search },
  { path: '/community', label: 'Community', icon: Users },
  { path: '/live', label: 'Live', icon: Activity },
  { path: '/profile', label: 'Profile', icon: User },
];

export const MobileNav: React.FC = () => {
  return (
    <nav className="ymn-bar" aria-label="Mobile Navigation Systems">

      {/* Decorative Physical Rail Track Line Graphic */}
      <div className="ymn-track-line" aria-hidden="true" />

      <div className="ymn-tabs-container">
        {MOBILE_TABS.map((tab) => {
          const Icon = tab.icon;

          return (
            <NavLink
              key={tab.path}
              to={tab.path}
              end={tab.path === '/'}
              className={({ isActive }) =>
                `ymn-item ${isActive ? 'ymn-item--active' : ''}`
              }
            >
              {({ isActive }) => (
                <>
                  {/* Dynamic Train Transit Indicator Asset */}
                  <div className={`ymn-indicator ${isActive ? 'ymn-indicator--visible' : ''}`}>
                    <TrainFront size={11} className="ymn-indicator-train" />
                  </div>

                  {/* Operational Icon Wrapper */}
                  <div className="ymn-icon-wrapper">
                    <Icon size={20} strokeWidth={isActive ? 2.2 : 1.8} />
                  </div>

                  {/* Content Interface Typography */}
                  <span className="ymn-label">{tab.label}</span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNav;